import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { merge } from 'lodash-es';
import { FUSE_APP_CONFIG } from '@fuse/services/config/config.constants';

@Injectable({
  providedIn: 'root'
})
export class FuseConfigService {
  private c: any;

  /**
   * Constructor
   */
  constructor(@Inject(FUSE_APP_CONFIG) config: any) {
    this.c = config;
    this._config = new BehaviorSubject(config);
    this.init();
  }

  public init() {
    if (!this.validateIsDefaultTheme()) {
      const savedConfig = JSON.parse(localStorage.getItem('fuse-config'));
      this.c = savedConfig ? savedConfig : this.c;
      this._config.next(this.c);
    }
  }

  private _config: BehaviorSubject<any>;

  /**
   * Setter & getter for config
   */
  set config(value: any) {
    // Merge the new config over to the current config
    const config = merge({}, this._config.getValue(), value);
    // Execute the observable
    this._config.next(config);
  }

  private validateIsDefaultTheme(): boolean {
    const isRestaurant = JSON.parse(localStorage.getItem('isRestaurant'));
    if (isRestaurant === false) {
      const config = merge({}, this._config.getValue(), { scheme: 'dark', theme: 'indigo' });
      this._config.next(config);
      return true;
    } else {
      return false;
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  get config$(): Observable<any> {
    return this._config.asObservable();
  }

  public initTheme(): void {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Resets the config to the default
   */
  reset(): void {
    // Set the config
    this._config.next(this.config);
  }
}
